<template>
  <div class="content">
    <!-- <div class="top">
      <div class="info">
        <img
          :src="avatarUrl"
          style="width: 80px; margin-left: 5px; margin-bottom: 20px"
          alt=""
        /><span style="font-size: 18px; color: #333333; margin-bottom: 20px">{{
          userInfo?.userName
        }}</span
        ><span style="font-size: 14px; color: #999999">{{
          userInfo?.deptName5
        }}</span>
      </div>
    </div>
    <div class="center">
      <div class="title">{{ $t("guide.basicInfo") }}</div>
      <div class="basic">
        <span style="margin-right: 50px"
          >{{ $t("profile.gender") }}：{{
            userInfo?.gender == "0" ? "男" : userInfo?.gender == "1" ? "女" : ""
          }}</span
        ><span>{{ $t("profile.idCard") }}：{{userInfo?.idNumber}}</span>
      </div>
    </div>
    <div class="bottom">
      <div class="title">{{ $t("profile.account") }}</div>
      <div class="table">
        <el-table :data="tabletData" style="width: 100%" @row-click="rowClick">
          <el-table-column prop="range" :label="$t('profile.accountName')">
          </el-table-column>
          <el-table-column prop="name" :label="$t('profile.dentity')">
          </el-table-column>
          <el-table-column
            prop="deptName"
            :label="$t('profile.affiliation')"
          ></el-table-column>
          <el-table-column prop="groupName" :label="$t('profile.expiryDate')">
          </el-table-column>
          <el-table-column prop="line" :label="$t('profile.active')">
          </el-table-column>
          <el-table-column prop="line" :label="$t('profile.status')">
          </el-table-column>
          <el-table-column prop="line" :label="$t('profile.defaultAccount')">
          </el-table-column>
          <el-table-column prop="line" :label="$t('profile.operations')">
            <template slot-scope="scope">
              <el-button @click="isCollect(scope.row)" type="text" size="small"
                >{{
                  scope.row?.favorite
                    ? $t("profile.cancelDefault")
                    : $t("profile.default")
                }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div> -->
    <div class="top">
      <div class="one">
        <span style="font-size: 20px; color: #333333; margin-bottom: 15px"
          >{{ $t("home.hi") }}{{ userInfo?.userName }}！</span
        ><span style="font-size: 14px; color: #666666; margin-bottom: 15px"
          >{{ $t("profile.todayis") }}{{ todayDate }}，{{
            $t("profile.welcome")
          }} </span
        ><span style="font-size: 14px; color: #666666">{{
          $t("main.title")
        }}</span>
      </div>
      <div>
        <img
          src="@/assets/img/personal/dunpai.png"
          style="width: 120px; margin-left: 5px"
          alt=""
        />
      </div>
      <div class="two">
        <div style="margin-bottom: 10px">
          <span style="font-weight: bold; font-size: 28px; color: #3b66ff">{{
            userInfo?.accountScore
          }}</span
          ><span style="font-size: 14px; color: #3b66ff">{{
            $t("profile.point")
          }}</span>
        </div>
        <span style="margin-bottom: 10px">{{
          userInfo?.accountScore > 60
            ? $t("profile.fengxian")
            : $t("profile.fengxian1")
        }}</span>
        <el-button
          type="primary"
          style="width: auto"
          @click="toGood"
          v-if="!qstData && !tabletData && !userInfo.email && !userInfo.phone"
          >{{ $t("profile.goGood") }}</el-button
        >
      </div>
      <div>
        <img
          src="@/assets/img/personal/personLogo.png"
          style="width: 160px; margin-left: 20px"
          alt=""
        />
      </div>
    </div>
    <div class="center">
      <div class="title" v-if="isShow.includes('phone')">
        <div class="child">
          <span style="font-size: 16px; color: #333333; margin-bottom: 8px">{{
            $t("profile.myPhone")
          }}</span
          ><span style="font-size: 14px; color: #666666; margin-bottom: 15px">{{
            userInfo.phone ? "已绑定" : "建议绑定手机"
          }}</span
          ><span
            style="font-size: 14px; cursor: pointer"
            @click="toPhone"
            :style="{ color: userInfo.phone ? '#3B66FF' : '#F5222D' }"
            >{{ userInfo.phone ? "去查看 >" : "去绑定 >" }}</span
          >
        </div>
        <div>
          <img
            src="@/assets/img/personal/sjbd.png"
            style="width: 80px; margin-left: 20px"
            alt=""
          />
        </div>
      </div>
      <div class="title" v-if="isShow.includes('email')">
        <div class="child">
          <span style="font-size: 16px; color: #333333; margin-bottom: 8px">{{
            $t("profile.myEmail")
          }}</span
          ><span style="font-size: 14px; color: #666666; margin-bottom: 15px">{{
            userInfo.email
              ? $t("profile.yibangding")
              : $t("profile.weibangding")
          }}</span
          ><span
            style="font-size: 14px; cursor: pointer"
            @click="toEmail"
            :style="{ color: userInfo.email ? '#3B66FF' : '#F5222D' }"
            >{{
              userInfo.email
                ? $t("profile.quchakan") + " >"
                : $t("profile.weibangding") + " >"
            }}</span
          >
        </div>
        <div>
          <img
            src="@/assets/img/personal/yxbd.png"
            style="width: 80px; margin-left: 20px"
            alt=""
          />
        </div>
      </div>
      <div class="title">
        <div class="child">
          <span style="font-size: 16px; color: #333333; margin-bottom: 8px">{{
            $t("profile.accbind")
          }}</span
          ><span style="font-size: 14px; color: #666666; margin-bottom: 15px">{{
            tabletData.length > 0
              ? $t("profile.yibangding")
              : $t("profile.weibangding")
          }}</span
          ><span
            style="font-size: 14px; cursor: pointer"
            @click="toAccount"
            :style="{ color: tabletData.length > 0 ? '#3B66FF' : '#F5222D' }"
            >{{
              tabletData.length > 0
                ? $t("profile.quchakan") + " >"
                : $t("profile.weibangding") + " >"
            }}</span
          >
        </div>
        <div>
          <img
            src="@/assets/img/personal/zhbd.png"
            style="width: 80px; margin-left: 20px"
            alt=""
          />
        </div>
      </div>
      <div class="title">
        <div class="child">
          <span style="font-size: 16px; color: #333333; margin-bottom: 8px">{{
            $t("profile.mibao")
          }}</span
          ><span style="font-size: 14px; color: #666666; margin-bottom: 15px">{{
            qstData.length > 0
              ? $t("profile.setmibao")
              : $t("profile.nosetmibao")
          }}</span
          ><span
            style="font-size: 14px; cursor: pointer"
            @click="toQuestion"
            :style="{ color: qstData.length > 0 ? '#3B66FF' : '#F5222D' }"
            >{{
              qstData.length > 0
                ? $t("profile.quchakan") + " >"
                : $t("profile.goset") + " >"
            }}</span
          >
        </div>
        <div>
          <img
            src="@/assets/img/personal/mbbd.png"
            style="width: 80px; margin-left: 20px"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="bottom">
      <div
        style="
          font-weight: bold;
          font-size: 16px;
          color: #333333;
          margin-bottom: 20px;
        "
      >
        {{ $t("profile.loginHistory") }}
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="browser" :label="$t('profile.browser')">
        </el-table-column>
        <el-table-column prop="os" :label="$t('profile.os')"> </el-table-column>
        <el-table-column prop="loginWay" :label="$t('profile.loginWay')">
        </el-table-column>
        <el-table-column prop="msg" :label="$t('profile.msg')">
        </el-table-column>
        <el-table-column prop="loginTime" :label="$t('profile.loginTime')">
        </el-table-column>
      </el-table>
      <div
        style="font-size: 14px; color: #3b66ff; margin: 20px; cursor: pointer"
        @click="toMoreLog"
        v-if="tableData.length > 0"
      >
        {{ $t("home.viewMore") }} >
      </div>
    </div>
  </div>
</template>
<script>
// import { getLoggedUserInfo } from "@/api/modules/user";
import { getImageUrl } from "@/utils/imageHelper";
import request from "@/api/request";
export default {
  data() {
    return {
      avtor: require("@/assets/img/personal/avtor.png"),
      tableData: [],
      userInfo: {},
      details: {},
      todayDate: "",
      tabletData: [],
      qstData: [],
      isShow: "",
      localStorageValue: localStorage.getItem('locale') || '',
      originalSetItem: null,
    };
  },
  computed: {
    // 计算属性方式
    avatarUrl() {
      return getImageUrl(this.avtor);
    },
  },
  created() {
    this.userInfo = {
      ...JSON.parse(localStorage.getItem("accountInfo"))?.data,
    };
    this.avtor = this.userInfo?.avatar;
    // getLoggedUserInfo().then((res) => {
    //   this.details = res.data;
    // });
    if (localStorage.getItem("allConfig")) {
      let allData = [...JSON.parse(localStorage.getItem("allConfig"))];
      for (let i = 0; i <= allData.length; i++) {
        if (allData[i]?.key == "sys.second.validate.way") {
          this.isShow = allData[i]?.value;
        }
      }
    }
    this.getTodayDate();
    this.getTableData();
    this.getDataList();
    this.getQsData();
        console.log(this.$route.query)
    if (this.$route.query.isEdit) {
      this.$emit("toComponent", undefined, "editPassword");
    }
  },
  watch: {
    // 监听桥接数据的变化（核心）
    localStorageValue(newVal, oldVal) {
      console.log('localStorage变化：', { oldVal, newVal })
      // 这里写你的业务逻辑
      this.getTodayDate()
    }
  },
    // 新增mounted钩子（关键）
  mounted() {
    // 1. 监听其他标签页的localStorage变化
    window.addEventListener('storage', this.handleStorageEvent);
    // 2. 重写setItem，监听当前标签页的locale修改
    this.overrideLocalStorageSetItem();
  },
  // 新增beforeDestroy钩子（防止内存泄漏）
  beforeDestroy() {
    window.removeEventListener('storage', this.handleStorageEvent);
    // 恢复原生setItem方法
    if (this.originalSetItem) {
      localStorage.setItem = this.originalSetItem;
    }
  },
  methods: {
    toGood() {
      if (
        !userInfo.email &&
        tabletData.length == 0 &&
        qstData.length == 0 &&
        !userInfo.phone
      ) {
        this.$emit("toComponent", undefined, "accountBinding");
      } else if (
        !userInfo.email &&
        tabletData.length > 0 &&
        qstData.length == 0 &&
        !userInfo.phone
      ) {
        this.$emit("toComponent", undefined, "securityCenter");
      } else if (
        !userInfo.email &&
        tabletData.length > 0 &&
        qstData.length == 0 &&
        userInfo.phone
      ) {
        this.$emit("toComponent", undefined, "otherAccount");
      } else if (
        userInfo.email &&
        tabletData.length > 0 &&
        qstData.length == 0 &&
        userInfo.phone
      ) {
        this.$emit("toComponent", undefined, "passwordQuestion");
      }
    },
    getQsData() {
      request({
        url: `/api/user/qa/list`,
        method: "get",
      })
        .then((res) => {
          this.qstData = [...res?.data];
        })
        .catch((error) => {});
    },
    getDataList() {
      request({
        url: `/api/user/ref/list`,
        method: "get",
      })
        .then((res) => {
          this.tabletData = [...res];
        })
        .catch((error) => {});
    },
    toQuestion() {
      this.$emit("toComponent", undefined, "passwordQuestion");
    },
    toAccount() {
      this.$emit("toComponent", undefined, "accountBinding");
    },
    toPhone() {
      this.$emit("toComponent", undefined, "securityCenter");
    },
    toEmail() {
      this.$emit("toComponent", undefined, "otherAccount");
    },
    toMoreLog() {
      this.$emit("toComponent", undefined, "loginLog");
    },
    getTableData() {
      request({
        url: `/api/user/loginlog`,
        method: "post",
        data: {
          pageNum: 1,
          pageSize: 10,
        },
      })
        .then((res) => {
          this.tableData = [...res?.rows];
          this.totalPages = res?.total;
        })
        .catch((error) => {});
    },
    getTodayDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      const formatMonth = month < 10 ? `0${month}` : month;
      const formatDay = day < 10 ? `0${day}` : day;

      const weekMap = ["日", "一", "二", "三", "四", "五", "六"];
      const weekMapEn = [
        "Sunday", "Monday", "Tuesday", "Wednesday", 
        "Thursday", "Friday", "Saturday"
      ];
      const monthMap = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      const monthMapEn = monthMap[now.getMonth()];
      const weekDayEn = weekMapEn[now.getDay()];
      const weekDay = weekMap[now.getDay()];
      // 修复：isLang可能未定义的问题，直接取localStorageValue
      const isLang = this.localStorageValue;
      
      this.todayDate = isLang === "zh"
        ? `${year}年${formatMonth}月${formatDay}日 星期${weekDay}`
        : isLang === "en"
          ? `${monthMapEn}, ${formatDay}, ${year} ${weekDayEn}`
          : '';
    },
        // 新增：处理其他标签页的storage事件
    handleStorageEvent(e) {
      // 只监听locale字段的变化
      if (e.key === 'locale') {
        this.localStorageValue = e.newValue || '';
      }
    },
    // 新增：重写localStorage.setItem，监听当前标签页的修改
    overrideLocalStorageSetItem() {
      // 保存原生方法
      this.originalSetItem = localStorage.setItem;
      // 重写setItem
      localStorage.setItem = (key, value) => {
        // 执行原生逻辑
        this.originalSetItem.call(localStorage, key, value);
        // 如果是locale字段，更新响应式数据
        if (key === 'locale') {
          this.localStorageValue = value;
        }
      };
    },
    rowClick(row) {
      this.$refs.table.toggleRowSelection(row);
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-table__header th {
  background: #f6f8fc;
  font-weight: bold;
  color: #666666;
}
::v-deep .el-table th.el-table__cell {
  background: #f6f8fc;
}
.content {
  display: flex;
  flex-direction: column;
  padding: 20px 35px;
  .top {
    // width: 1120px;
    height: 160px;
    background: #e1e7ff;
    box-shadow: 0px 3px 8px 1px rgba(112, 112, 112, 0.16);
    border-radius: 10px 10px 10px 10px;
    display: flex;
    align-items: center;
    padding: 0 30px;
    .one {
      display: flex;
      flex-direction: column;
      margin-right: 50px;
    }
    .two {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
  }
  .center {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    .title {
      display: flex;
      padding: 13px;
      background: #f6f8fc;
      border-radius: 10px 10px 10px 10px;
      .child {
        display: flex;
        flex-direction: column;
      }
    }
  }
  // .top {
  //   height: 280px;
  //   background-image: url("@/assets/img/personal/accountBg.png");
  //   background-size: contain;
  //   background-repeat: no-repeat;
  //   width: 100%;
  //   border-bottom: 1px solid #dfdfdf;
  //   position: relative;
  //   .info {
  //     display: flex;
  //     flex-direction: column;
  //     position: absolute;
  //     top: 10%;
  //     left: 5%;
  //   }
  // }
  // .center {
  //   padding: 15px;
  //   width: 100%;
  //   .title {
  //     border-left: 3px solid #6293ff;
  //     padding-left: 8px;
  //     display: flex;
  //     align-items: center;
  //     margin-bottom: 20px;
  //     font-size: 16px;
  //     color: #333333;
  //   }
  //   .basic {
  //     font-size: 14px;
  //     color: #666666;
  //     background: #f5f7fb;
  //     border-radius: 4px 4px 4px 4px;
  //     padding: 20px;
  //   }
  // }
  // .bottom {
  //   padding: 15px;
  //   width: 100%;
  //   ::v-deep .el-table__header th {
  //     background-color: #f5f7fb;
  //     font-weight: bold;
  //     color: #333333;
  //   }
  //   .title {
  //     border-left: 3px solid #6293ff;
  //     padding-left: 8px;
  //     display: flex;
  //     align-items: center;
  //     margin-bottom: 20px;
  //     font-size: 16px;
  //     color: #333333;
  //   }
  // }
}
</style>
